import type { ConfirmOptions } from '../ui/dialogs';
import { Modal } from '../ui/Modal';

interface Props extends ConfirmOptions {
  /** Called with the answer. Closing the dialog any other way counts as "no". */
  onAnswer: (confirmed: boolean) => void;
}

export function ConfirmDialog({ title, message, confirmLabel = 'Confirm', cancelLabel = 'Keep it', danger = false, onAnswer }: Props) {
  return (
    <Modal title={title} titleId="confirm-title" onClose={() => onAnswer(false)}>
      <p>{message}</p>
      <div className="dialog-actions">
        <button type="button" className="btn btn-secondary" onClick={() => onAnswer(false)}>
          {cancelLabel}
        </button>
        <button type="button" className={`btn ${danger ? 'btn-danger' : ''}`.trim()} onClick={() => onAnswer(true)}>
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
